import { LoginForm } from "../components/loginForm";

export default function LoginPage(){
    return <LoginForm/>
}